<template>
  <div class="w-full bg-white height-100">
    <div class="seth-set bg-primary">
      <div class="object-cover bg-primary ban-marcom60 w-full"></div>
      <div class="absolute top-0 py-10 w-full px-6 flex">
        <div>
          <p
            @click="handleBack"
            class="gap-2 cursor-pointer fsize14 mb-1 text-white flex items-center font-medium"
          >
            <feather-icon icon="ArrowLeftIcon" svgClasses="w-6 h-6" />
            Go Back
          </p>
        </div>
      </div>
    </div>
    <div
      class="flex justify-center pb-20 pt-32 menucontrol-scroll fixed-top items-center"
    >
      <div>
        <div class="flex justify-center">
          <img
            src="https://nimbus-server-01.s3.ap-south-1.amazonaws.com/Brained/assets/hello.png"
            class="w-100px"
          />
        </div>
        <div class="text-center mt-4">
          <h4 class="font-semibold text-4d4d4d text-3xl">
            All done! Time to review
          </h4>
          <p class="fsize14 col-4f">
            Your Campaign is under review. We will <br />
            notify its status shortly
          </p>
        </div>
        <div class="flex gap-4 mt-6 justify-center items-center">
          <vs-button
            class="border-0 text-white font-medium fsize14 py-4 px-10 sm-fsize14"
          >
            Visit Planner
          </vs-button>
          <vs-button
            type="success"
            class="border-0 bg-success text-white font-medium fsize14 py-4 px-8 sm-fsize14"
          >
            View My Templates
          </vs-button>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
// import VueEllipseProgress from "vue-ellipse-progress";

export default {
  methods: {
    handleClick(name) {
      this.$router.push({ name: name });
    },
  },
};
</script>
